import { render } from "./RedirectToLogin.vue?vue&type=template&id=133e5478&scoped=true&ts=true"
import script from "./RedirectToLogin.ts?vue&type=script&lang=ts&external"
export * from "./RedirectToLogin.ts?vue&type=script&lang=ts&external"

import "./RedirectToLogin.scss?vue&type=style&index=0&id=133e5478&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133e5478"]])

export default __exports__